import { z } from "zod/v4";

export const GoogleLoginResponseSchema = z.object({
  redirect: z.string(),
});

export type GoogleLoginResponseType = z.infer<typeof GoogleLoginResponseSchema>;
